import { BasketItem } from "services/api/order/model";

import { CheckoutItems } from "../checkout/model";

export interface IMobileAppConfig {
  showNutritionalInformation: boolean;
  googleMapsApiKey: string | null;
  cutleryProductId: number;
  enableRequestCutlery: boolean;
  futureOrdersLimit: number;
  currentOrderExpiry: number;
  dashboard: IDashboard[];
  referAFriend: IReferAFriend;
  freeProducts: {
    cutlery: {
      categoryId: number;
      productId: number;
      posPlu: number;
    };
  };
  httpTimeout: number;
  termsAndConditions: string;
  privacyPolicy: string;
  mobileAppVersion: MobileAppVersion;
  zendeskSupportFormUrl?: string;
}

interface MobileAppVersion {
  miniOSBuildNumber: number;
  minAndroidBuildNumber: number;
  header: string;
  message: string;
  buttonName: string;
  playStoreLink: string;
  appStoreLink: string;
}

export enum DashboardSection {
  CURRENT_ORDERS = "Current Orders",
  RECENT_ORDERS = "Recent Orders",
  REWARDS = "Rewards",
  FAVOURITES = "Favourites",
  PROMOTIONS = "Promotions",
}

export interface IDashboard {
  id: number;
  componentName: DashboardSection;
  displayOrder: number;
  isVisible: boolean;
  channeltype: 0 | 1 | 2; //  0 = All platforms, 1 = App only, 2 = Web only
}

export interface IDashboardState {
  getMobileAppConfigLoading: boolean;
  getMobileAppConfigError: boolean;
  mobileAppConfig: IMobileAppConfig | null;
  recentOrderToAddToCart: CheckoutItems[] | BasketItem[];
}

export interface IReferAFriend {
  rewardDescription: string;
  expiryDate?: string;
  description: string;
  stepsTitle: string;
  steps: string[];
  imageUrl?: string;
  termsConditionsTitle: string;
  termsConditionsUrl: string;
  shareButtonTitle: string;
  shareMessage: string;
}
